import { useState, useMemo } from 'react';

/**
 * Hook for filtering and searching columns.
 * @param {Array} kolonnen 
 * @param {Array} workers 
 * @param {Array} vehicles 
 */
export function useKolonnenFilters(kolonnen, workers, vehicles) {
    const [searchTerm, setSearchTerm] = useState('');
    const [filterWorker, setFilterWorker] = useState([]);
    const [filterVehicle, setFilterVehicle] = useState([]);
    const [initialized, setInitialized] = useState(false);

    // Initialize with all IDs once data is loaded
    useMemo(() => {
        if (!initialized && workers.length > 0 && vehicles.length > 0) {
            setFilterWorker(workers.map(w => String(w.id)));
            setFilterVehicle(vehicles.map(v => String(v.id)));
            setInitialized(true);
        }
    }, [workers, vehicles, initialized]);

    const processedKolonnen = useMemo(() => {
        let result = [...kolonnen];

        // 1. Search
        if (searchTerm) {
            const lowerSearch = searchTerm.toLowerCase();
            result = result.filter(k => {
                const nameMatches = k.name?.toLowerCase().includes(lowerSearch);
                const codeMatches = k.code?.toLowerCase().includes(lowerSearch);
                
                // Search in members
                const memberMatches = k.members?.some(m => {
                    if (m.type === 'worker') {
                        const worker = workers.find(w => w.id === m.resource_id);
                        if (!worker) return false;
                        const workerName = worker.name || `${worker.first_name || ''} ${worker.last_name || ''}`;
                        return workerName.toLowerCase().includes(lowerSearch);
                    } else if (m.type === 'vehicle') {
                        const vehicle = vehicles.find(v => v.id === m.resource_id);
                        if (!vehicle) return false;
                        return (
                            vehicle.license_plate?.toLowerCase().includes(lowerSearch) ||
                            vehicle.name?.toLowerCase().includes(lowerSearch) ||
                            vehicle.vehicle_type?.toLowerCase().includes(lowerSearch) ||
                            (vehicle.type || 'pkw').toLowerCase().includes(lowerSearch)
                        );
                    }
                    return false;
                });

                return nameMatches || codeMatches || memberMatches;
            });
        }

        // 2. Filter by Worker (only if not all are selected!)
        if (filterWorker.length > 0 && filterWorker.length < workers.length) {
            result = result.filter(k => 
                k.members?.some(m => m.type === 'worker' && filterWorker.includes(String(m.resource_id)))
            );
        }

        // 3. Filter by Vehicle (only if not all are selected!)
        if (filterVehicle.length > 0 && filterVehicle.length < vehicles.length) {
            result = result.filter(k => 
                k.members?.some(m => m.type === 'vehicle' && filterVehicle.includes(String(m.resource_id)))
            );
        }

        return result;
    }, [kolonnen, workers, vehicles, searchTerm, filterWorker, filterVehicle]);

    return {
        searchTerm, setSearchTerm,
        filterWorker, setFilterWorker,
        filterVehicle, setFilterVehicle,
        processedKolonnen
    };
}
